import { render, staticRenderFns } from "./AtualizarPerfil.vue?vue&type=template&id=48658960&"
import script from "./AtualizarPerfil.vue?vue&type=script&lang=js&"
export * from "./AtualizarPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports